import { TimeFrameEnum } from "enums/AnalyticsTimeFrame";
import type { Employee } from "components/common/EmployeeSearchAutoComplete";
import type { Card } from "components/admin/cards/CardSearchAutoComplete";
import type { ExpenseCategory } from "components/common/CategorySearchAutoComplete";
import type { SelectedAllocation } from "components/common/AllocationSearchAutoComplete";
import type { AllocationType } from "utils/allocations/allocationOptions";

export const DEFAULT_TIME_FRAME = TimeFrameEnum.LAST_90_DAYS;

export interface AnalyticsFilters {
  accountId: string | null;
  timeFrame: TimeFrameEnum;
  expenseCategory: ExpenseCategory | null;
  employee: Employee | null;
  card: Card | null;
  allocationType: AllocationType | null;
  allocation: SelectedAllocation | null;
}

export const DEFAULT_ANALYTICS_FILTERS: AnalyticsFilters = {
  accountId: null,
  timeFrame: DEFAULT_TIME_FRAME,
  expenseCategory: null,
  employee: null,
  card: null,
  allocationType: null,
  allocation: null,
};

/** Clears what the drawer sets and keeps the account and timeframe the bar sets. */
export const clearDrawerFilters = (
  filters: AnalyticsFilters,
): AnalyticsFilters => ({
  ...filters,
  expenseCategory: null,
  employee: null,
  card: null,
  allocationType: null,
  allocation: null,
});

/** Filters that differ from the defaults. An allocation counts once, with its type. */
export const appliedFilterCount = (filters: AnalyticsFilters): number =>
  [
    filters.accountId !== null,
    filters.timeFrame !== DEFAULT_TIME_FRAME,
    filters.expenseCategory !== null,
    filters.employee !== null,
    filters.card !== null,
    filters.allocation !== null,
  ].filter(Boolean).length;
